import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { ExperienceAreaService } from '../experience-area.service';
import { ExperienceEngagementsService } from './experience-engagements.service';
import { ExperienceEngagementsTab1Part } from './tabs/tab-1/experience-engagements-tab-1.part';
import { ExperienceEngagementsTab2Part } from './tabs/tab-2/experience-engagements-tab-2.part';
import { ExperienceEngagementsViewsPart } from './views/engagements-views.part';


@Component({
	selector: 'experience-engagements-page',
	standalone: true,
	imports: [
		ExperienceEngagementsTab1Part,
		ExperienceEngagementsTab2Part,
		ExperienceEngagementsViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		TrimesterDroplistWidget,
		DroplistWidget,
		ToolbarWidget,
		PageTabsWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './experience-engagements.page.html',
})
export class ExperienceEngagementsPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;
	public experienceService = inject(ExperienceAreaService);

	constructor(public pageService: ExperienceEngagementsService) { }

	async ngOnInit() {
		await this.experienceService.loadExperienceData();
	}


	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}